import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { ReactNode } from 'react'

export default function WarningCallout({ children }: { children: ReactNode }) {
    return (
        <div className="border-l-4 border-yellow-400 bg-yellow-50 p-4 my-4">
            <div className="flex">
                <div className="shrink-0">
                    <ExclamationTriangleIcon
                        aria-hidden="true"
                        className="h-5 w-5 text-yellow-400"
                    />
                </div>
                <div className="ml-3">
                    <p className="text-sm text-yellow-700">{children}</p>
                </div>
            </div>
        </div>
    )
}
